import { StencilThemes } from './components/StencilThemes';
import * as themes from './themes';

const themeAliases = {
  'Labor Day 26 - Primary 1': 'LaborDay2026PrimaryOne',
  'Labor Day 26 - Primary 2': 'LaborDay2026PrimaryTwo',
  'Labor Day 26 - Primary 3': 'LaborDay2026PrimaryThree',
  'Labor Day 26 - Secondary 1': 'LaborDay2026SecondaryOne',
  'Labor Day 26 - Secondary 2': 'LaborDay2026SecondaryTwo',
  'Black Friday (BF) 26 - Primary 1': 'BlackFriday2026PrimaryOne',
  'Black Friday (BF) 26 - Primary 2': 'BlackFriday2026PrimaryTwo',
  'Black Friday (BF) 26 - Secondary 1': 'BlackFriday2026SecondaryOne',
  'Black Friday (BF) 26 - Secondary 2': 'BlackFriday2026SecondaryTwo',
  'Winter Holiday 26 - Primary 1': 'WinterHoliday2026PrimaryOne',
  'Winter Holiday 26 - Primary 2': 'WinterHoliday2026PrimaryTwo',
  'Winter Holiday 26 - Primary 3': 'WinterHoliday2026PrimaryThree',
  'Winter Holiday 26 - Primary 4': 'WinterHoliday2026PrimaryFour',
  'Winter Holiday 26 - Primary 5': 'WinterHoliday2026PrimaryFive',
  'Winter Holiday 26 - Primary 6': 'WinterHoliday2026PrimarySix',
  'Winter Holiday 26 - Primary 7': 'WinterHoliday2026PrimarySeven',
  'Behr 2026 26 - Grounded': 'Behr2026Grounded',
  'Halloween 26 - Primary 1 Purple': 'Halloween2026PrimaryOne',
  'Cyber Monday 26 - Primary 1 Green': 'CyberMonday2026PrimaryOne',
  'Cyber Monday 26 - Primary 2 Blue': 'CyberMonday2026PrimaryTwo'
};

const getThemeByName = (name) => {
  const resolvedName = themeAliases[name] || name;
  const themeName = Object.keys(themes).find((key) => key === resolvedName) ? resolvedName : 'DefaultTheme';
  return themes[themeName];
};

export { StencilThemes, themes, getThemeByName };
